module.exports = __webpack_public_path__ + "static/media/37.f20b5b9a.jpg";